import React, { useState, useEffect } from 'react'
import { useTheme, Box } from '@mui/material'
import Chip from '@mui/material/Chip'

import Tabs from './components/Tabs'
import SearchField from './components/SearchField'

//Types / Enum
import { FasDataItemPlanningStatus } from './types'

//UTILS
import {
  calculateFasDataStats,
  getTabsWithCounts,
  includesAnyOfFullWords,
  splitToNormalizedWords,
  useGetFasDataHook,
  wellKnownGeography,
  map,
} from './utils'
import { IssueListWithPagination } from './components/IssueListWithPagination'
import AlertBanner from '../../AlertBanner'

const Telephony = () => {
  const { palette, breakpoints } = useTheme()
  const styles = {
    chipArray: {
      margin: 0,
      padding: '0px !important',
      display: 'flex',
      flexWrap: 'wrap',
      gap: '5px',
      '& li': {
        listStyle: 'none',
        marginBottom: '0px !important',
      },
    },
    chip: {
      '&.MuiChip-colorPrimary': {
        color: palette.common.black,
      },

      '& > span': {
        fontSize: '13px',
      },
    },
    filters: {
      display: 'grid',
      justifyContent: 'space-between',
      alignItems: 'flex-end',
      gridTemplateColumns: '1fr 1fr',
      gap: '16px',
      marginTop: '32px',
      marginBottom: '16px',

      [breakpoints.down('md')]: {
        gridTemplateColumns: '1fr',
      },

      '& > div': {
        flex: 1,
      },
    },
  }
  const { fasData, fasDataFetchError } = useGetFasDataHook()
  /**
   * React State
   */
  const [selectedGeoFilters, setSelectedGeoFilters] = useState(0)
  const [selectedTabId, setSelectedTab] = useState(FasDataItemPlanningStatus.Unplanned)
  const [globalTextSearch, setGlobalTextSearch] = useState('')
  const [effectiveStats, setEffectiveStats] = useState(fasData?.stats)
  const [tabs, setTabs] = useState(getTabsWithCounts(effectiveStats, selectedGeoFilters))

  useEffect(() => {
    const searchWords = splitToNormalizedWords(globalTextSearch)
    const textFilteredItems = fasData?.all.filter(item => includesAnyOfFullWords(item, searchWords))
    const effectiveStats = textFilteredItems === undefined ? fasData?.stats : calculateFasDataStats(textFilteredItems)

    setEffectiveStats(effectiveStats)
    setTabs(getTabsWithCounts(effectiveStats, selectedGeoFilters))
  }, [fasData, selectedGeoFilters, globalTextSearch])

  if (fasDataFetchError) {
    return (
      <AlertBanner
        severity="error"
        id="driftsinformation-error-alert"
        title="Noget gik galt!"
        description="Prøv at opdatere siden"
        inlineAlert={true}
      />
    )
  }

  return (
    <Box>
      <Box component="ul" sx={styles.chipArray}>
        {wellKnownGeography.values.map((d, i) => {
          const isFlagged = wellKnownGeography.isValueFlagged(selectedGeoFilters, d)
          return (
            <li key={i}>
              <Chip
                sx={{ ...styles.chip, ...{ backgroundColor: isFlagged ? palette.grey[300] : '' } }}
                variant="outlined"
                label={d}
                clickable
                onClick={e =>
                  setSelectedGeoFilters(previousState =>
                    map(wellKnownGeography.calcFlag(d), flag =>
                      e.ctrlKey ? previousState ^ flag : previousState === flag ? 0 : flag,
                    ),
                  )
                }
              />
            </li>
          )
        })}
      </Box>
      <Box sx={styles.filters}>
        <Tabs {...{ tabs, selectedTabId, setSelectedTab }} />
        <SearchField onSearchTextChanged={setGlobalTextSearch} />
      </Box>
      <IssueListWithPagination
        globalTextSearch={globalTextSearch}
        selectedGeoFilters={selectedGeoFilters || wellKnownGeography.allFlag}
        selectedPlanningStatus={selectedTabId}
      />
    </Box>
  )
}

export default Telephony
